import React from 'react';

import { Loader } from '../Loader';
import { calculateEditorHeight } from '../../shared/helpers';

export const MONACO_EDITOR_PADDING_TOP_AND_BOTTOM = 12 + 12; // defined in `.monaco-editor` in `SourceCodeEditor.scss`

interface MonacoEditorPlaceholderProps {
  code: string;
  maxVisibleLines?: number;
}

export function MonacoEditorPlaceholder({ code, maxVisibleLines }: Readonly<MonacoEditorPlaceholderProps>) {
  const numberOfLines = code.split('\n').length;
  const height = MONACO_EDITOR_PADDING_TOP_AND_BOTTOM + calculateEditorHeight(numberOfLines, { maxVisibleLines });
  return <Loader active={true} inline="centered" size="medium" style={{ height }} />;
}
